import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const ControlledDrug3Badge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-pink-500 text-white">
      {t('component:badge.controlledDrugLevel3')}
    </Badge>
  );
};
